<template>
  <v-card
    :href="typeof href !== 'undefined' && eservice === false ? href : undefined"
    :to="typeof to !== 'undefined' && eservice === false ? { name: to, params: { lang: $i18n.locale } } : undefined"
    outlined
    class="mx-auto overflow-hidden"
  >
    <v-img
      :aspect-ratio="2"
      :src="`${publicPath}img/${image}`"
      width="100%"
    />
    <v-card-title
      class="long-title-wrap"
    >
      {{ title }}
    </v-card-title>
    <v-card-subtitle>
      {{ text }}
    </v-card-subtitle>
    <v-card-actions v-if="eservice">
      <v-btn
        v-if="typeof to !== 'undefined' || typeof href !== 'undefined'"
        outlined
        :x-small="$vuetify.breakpoint.xsOnly"
        :href="typeof href !== 'undefined' ? href : undefined"
        :to="typeof to !== 'undefined' ? { name: to, params: { lang: $i18n.locale } } : undefined"
        color="green"
      >
        {{ $t('card.eservice') }}
      </v-btn>
      <v-btn
        v-if="tutorialName"
        :x-small="$vuetify.breakpoint.xsOnly"
        outlined
        color="blue"
        :href="'https://www.geoportal2.pl/pl/instrukcje/' + tutorialName + '/'"
        target="_blank"
      >
        {{ $t('card.manual') }}
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="share"
        icon
      >
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Cards',
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      default: undefined,
      type: String,
      required: false
    },
    image: {
      default: undefined,
      type: String,
      required: false
    },
    url: {
      default: undefined,
      type: String,
      required: false
    },
    to: {
      default: undefined,
      type: String,
      required: false
    },
    tutorialName: {
      default: undefined,
      type: String,
      required: false
    },
    eservice: {
      default: false,
      type: Boolean,
      required: false
    },
    bbox: {
      default: '',
      type: String,
      required: false
    },
    layers: {
      default: undefined,
      type: Array,
      required: false
    },
    qlayers: {
      default: undefined,
      type: Array,
      required: false
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      share: false
    }
  },
  computed: {
    href () {
      if (typeof this.layers !== 'undefined') {
        // TODO odporność na puste myqlayers
        return this.url + '&mylayers=%20' + this.layers.join('%20') + '&myqlayers=%20' + this.qlayers.join('%20') + '&bbox=' + this.bbox
      } else {
        return this.url
      }
    }, // TODO PO CO TO?
    ...mapState([
      'darkMode'
    ]),
    revealBackground: function () {
      return {
        'grey darken-3': this.darkMode,
        white: !this.darkMode
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .v-card--reveal {
    bottom: 0;
    opacity: .95;
    position: absolute;
    width: 100%;
  }
</style>
